module.exports = __webpack_public_path__ + "img/baner.c52a0f1a.png";